import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getERPgetStoreList } from '@/service/erpAPI';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
};

export const fetchERPgetStoreList = createAsyncThunk(
  'erpgetStoreList/fetchERPgetStoreList',
  async ({ query = {} }, { rejectWithValue }) => {
    try {
      const response = await getERPgetStoreList(query);
      return {
        data: response.data,
        query
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取ERP门店列表失败');
    }
  }
);

const erpgetStoreListSlice = createSlice({
  name: 'erpgetStoreList',
  initialState: defaultState,
  reducers: {
    resetERPgetStoreListState: (state) => {
      state.query = {};
      state.data = {};
      state.error = null;
      state.fetching = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchERPgetStoreList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchERPgetStoreList.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchERPgetStoreList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
});

export const { resetERPgetStoreListState } = erpgetStoreListSlice.actions;
export default erpgetStoreListSlice.reducer;
